function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../../locales/keys';
import { MINI_CART_MORE_ACTIONS, moreActionMenuItems } from '../../../../../wizards/tabs/summaryTab/summary.tab.helper';
import { ITEM_QUOTE_STATUS } from '../../../../../../customercare.constants';
import { determineClassForComponent } from '../cart.helper';
var FullCartOfferComponent = /*#__PURE__*/function () {
  function FullCartOfferComponent() {
    _classCallCheck(this, FullCartOfferComponent);
    Object.assign(this, {
      assignedClass: null,
      CustomerCareKeys: CustomerCareKeys,
      ITEM_QUOTE_STATUS: ITEM_QUOTE_STATUS,
      handleMoreOptionsMenuSelected: this.handleMoreOptionsMenuSelected.bind(this)
    });
  }
  return _createClass(FullCartOfferComponent, [{
    key: "$onInit",
    value: function $onInit() {
      if (this.isEdit || this.isChange || this.isNewConnect) {
        this.menuItems = moreActionMenuItems([MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER]);
      } else {
        this.menuItems = moreActionMenuItems([MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER, MINI_CART_MORE_ACTIONS.REMOVE]);
      }
      this.assignedClass = determineClassForComponent(this.showHideFullCartColumns);
    }
  }, {
    key: "showMoreMenuActions",
    value: function showMoreMenuActions() {
      if (this.isChange && this.offer.offeringInstanceId) {
        return this.offer.offeringInstanceId === '0';
      } else {
        return !this.offer.isPlaceHolderForExistingItems;
      }
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(option) {
      if (this.isEdit || this.isChange) {
        this.gotoDecisionsPage();
      } else {
        switch (option.item.id) {
          case MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER:
            this.handleEdit()(this.offer.offeringInstanceId);
            break;
          case MINI_CART_MORE_ACTIONS.REMOVE:
            this.handleRemove()(this.offer.offeringInstanceId);
            break;
          default:
            break;
        }
      }
    }
  }, {
    key: "onExpandToggleItems",
    value: function onExpandToggleItems(isExistingItemHeader, onLoad) {
      if (isExistingItemHeader) {
        this.expandExistingHeaderItems();
      }
      if (!onLoad) {
        this.onExpandToggle();
      }
    }
  }]);
}();
export default {
  bindings: {
    currency: '<',
    expandExistingHeaderItems: '&?',
    handleEdit: '&',
    handleRemove: '&',
    hideItem: '<?',
    isChange: '<?',
    isEdit: '<?',
    isExpanded: '<',
    isNewConnect: '<?',
    offer: '<',
    onExpandToggle: '&',
    gotoDecisionsPage: '&',
    showEdit: '<',
    showHideFullCartColumns: '<'
  },
  template: require('./full.cart.offer.html'),
  controller: FullCartOfferComponent
};